/* eslint-disable jsx-a11y/anchor-is-valid */
import "bootstrap/js/dist/dropdown";
import React from "react";
import { Col, NavDropdown, Navbar, Offcanvas, Row, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BsPersonCircle } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { Sidebar } from ".";
import { useAuth } from "../../../../../../providers";

export interface UserInfo {
  name: string,
  image: string | null
}

export const Header: React.FC<UserInfo> = (userInfo) => {
  const { handleLogout, userData } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation('admPanel');
  const expand = 'md';


  const UserControl = (isSmall) => {
    return (
      <>
        <a
          href="#"
          className={`text-decoration-none dropdown-toggle text-white d-none d-md-inline-flex`}
          type="button"
          id="triggerId"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <span className={`me-2 d-none d-sm-inline`}>{userInfo.name}</span>
          {userInfo.image
            ? <img
              alt={"Sua Foto"}
              src={userInfo.image}
              className={`rounded-circle ms-2 ${!isSmall ? `d-none d-md-inline-flex` : `d-md-none`}`}
              width={50}
              height={50}
              referrerPolicy="no-referrer"
            /> : <BsPersonCircle />}
        </a>
        <div className="dropdown-menu" aria-labelledby="triggerId">
          <a className="dropdown-item" href="/" onClick={async () => {
            navigate("/");
          }}>
            {t('back_to_site')}
          </a>
          <NavDropdown.Divider />
          <a className="dropdown-item" href="/" onClick={async () => {
            navigate("/");
            await handleLogout();
          }}>
            {t('logout')}
          </a>
        </div>
      </>
    )
  }
  return (
    <Row className="d-flex flex-row justify-content-between">
      <Col
        className="d-flex justify-content-between flex-column m-auto"
        style={{ paddingTop: "5px" }}
      >
        <a href="#" onClick={() => navigate("/")} className="text-decoration-none text-white">
          <span className="ms-3 pt-3 fs-4 d-inline" translate="no">
            <span className="montacar-orange-text">monta</span>
            <span className="montacar-blue-text">car</span>
          </span>
        </a>
      </Col>
      <Col
        xs={6}
        sm={4}
        md={3}
        className="align-self-right"
        style={{ paddingTop: "10px", paddingBottom: "10px" }}
      >
        <Stack direction="horizontal">
          <div className="dropdown open ms-auto">
            <Navbar expand={expand} className="p-0 d-md-none">
              <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} className="bg-body-tertiary" />
              <Navbar.Offcanvas
                id={`offcanvasNavbar-expand-${expand}`}
                aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                placement="end"
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                    Montacar
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <UserControl isSmall={true} />
                  <Sidebar isSmall={true} userType={userData.subscriber} adsStatus={""} />
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Navbar>
            <UserControl isSmall={false} />
          </div>
        </Stack>
      </Col>
    </Row>
  );
}
